exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{#content-panel[data-v-f8058c0a]{background-color:#fff}}#content-panel[data-v-f8058c0a]{min-height:49rem;font-family:Montserrat,sans-serif!important}", ""]);

// exports
